import { Component } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Spinner } from 'src/components/spiner';
import { CallInfo, DecryptedCallInfo, getCallnfo, registerParticipant, SourceInterface } from 'src/api';
import ParticipantInfoSourceForm from '../participant-info-source-form';
import { getFieldList } from './fieldListConference';

interface RegisterParticipantProps extends WithTranslation {
    callHash: string;
    onSuccess: (url: string) => void;
    openFileViewer?: (url: string) => void,
}

interface RegisterParticipantState {
    loading: boolean;
    callInfo: CallInfo;
    data: DecryptedCallInfo;
    error: boolean;
    mockSource: SourceInterface;
}

class RegisterParticipant extends Component<RegisterParticipantProps, RegisterParticipantState> {
    private forLegalEntities: boolean;
    private forMarket: boolean;
    private forBcc: boolean;

    constructor(props: RegisterParticipantProps) {
        super(props);
        const interfaceType = window.VBwidgetConfig.interfaceType;
        this.forLegalEntities = interfaceType === 'legal-entity';
        this.forMarket = interfaceType === 'market';
        this.forBcc = interfaceType === 'bcc';
        this.state = {
            loading: false,
            callInfo: null,
            error: null,
            data: null,
            mockSource: {
                ignoreWorkTime: false,
                showFirstPage: true,
                callType: 'video',
                // version for bcc
                fieldList: getFieldList(interfaceType),
            },
        };
    }

    public async componentDidMount() {
        const { callHash } = this.props;
        if (!callHash) {
            return;
        }
        await this.setCallInfo(callHash);
    }

    public async componentDidUpdate(prevProps: RegisterParticipantProps) {
        const prevCallhash = prevProps.callHash;
        const callHash = this.props.callHash;

        if (callHash !== prevCallhash) {
            await this.setCallInfo(callHash);
        }
    }

    private async setCallInfo(callHash: string) {
        this.setState({ loading: true });
        const callInfo = await getCallnfo(callHash);
        this.setState({ loading: false, callInfo });
    }

    private registerParticipant = async (data: DecryptedCallInfo) => {
        this.setState({ loading: true });
        try {
            const response = await registerParticipant({
                callHash: this.props.callHash,
                ...data
            });

            if (response.status !== 'OK') {
                this.setState({ error: true, loading: false, data });
                return;
            }

            this.props.onSuccess(response.url);
        } catch (e) {
            this.setState({ error: true, loading: false, data });
        }
    }

    render() {
        const { loading, callInfo, error, data, mockSource } = this.state;
        const legalEntityClassName = this.forLegalEntities
            ? 'vb-legal-entity'
            : '';
        const marketClassName = this.forMarket
            ? 'vb-market-widget'
            : '';
        const bccClassName = this.forBcc
            ? 'vb-bcc-widget'
            : '';

        if (loading) {
            return (
                <div className='vb-w-100 vb-h-100 vb-d-flex vb-align-items-center vb-justify-content-center'>
                    <Spinner colorSheme="primary" />
                </div>
            );
        }

        return (
            <div className={legalEntityClassName + marketClassName + bccClassName}>
                <ParticipantInfoSourceForm
                    error={error}
                    callInfo={callInfo}
                    data={data}
                    showOperatorCode={false}
                    onDataFilled={this.registerParticipant}
                    source={mockSource}
                    openFileViewer={this.props.openFileViewer}
                />
            </div>
        );
    }
}

export default withTranslation('register-participant')(RegisterParticipant);
